export const portalRouter = "";
export const dataMangeRouter = "manage";
export const systemMangeRouter = "manage/settings";

import APP_DINHPHUONGDO from "@/app_dinhphuongdo/router.js";

export default [...APP_DINHPHUONGDO("")];
